'use client'

import { Analytics, trackEvent } from '@a24/analytics'
import type { AnalyticsEvent } from '@a24/analytics'
import { useEffect } from 'react'

const TrackPage = ({
  title,
  event
}: { title?: string; event?: AnalyticsEvent }) => {
  useEffect(() => {
    Analytics.page({ title: title ?? document.title })
    if (event) trackEvent(event)
  }, [title, event])
  return null
}

export default TrackPage
